export default "__VITE_ASSET__13be3059__"